define('utils/colorizr-shaders',['jquery'], function($, color) {
    var hsv2rgb = "vec3 hsv2rgb(vec3 c) {\n" +
    "    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\n" +
    "    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n" +
    "    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n" +
    "}\n\n";

    var int2Float = "float int2Float(vec4 texelColour) {\n" +
    "    float sign = texelColour.a >= 0.5 ? -1.0 : 1.0;\n" +
    "    float exponent = ( texelColour.a >= 0.5 ? (texelColour.a - 0.5) * 510.0 : texelColour.a * 510.0 ) + ( texelColour.r >= 0.5 ? 1.0 : 0.0 ) - 127.0;\n" +
    "    float significand = texelColour.b * 255.0 + texelColour.g * 6520.0 + ( texelColour.r >= 0.5 ? ( texelColour.r - 0.5 ) * 16711680.0 : texelColour.r * 16711680.0 );\n" +
    "    if (exponent == -127.0) {\n" +
    "        exponent = -126.0;\n" +
    "        significand = significand / pow(2.0, 22.0);\n" +
    "    } else {\n" +
    "        significand = (significand + pow(2.0, 23.0)) / pow(2.0, 23.0);\n" +
    "    }\n" +
    "    return sign * significand * pow(2.0, exponent);\n" +
    "}\n\n";

    var textureSelect = function(size) {
        var textureSelectFrag = "vec4 textureSelect(int i) {\n" +
        "    vec4 texelColour;\n";
        if (size > 0) {
            for (var i = 0; i < size && i < 8; i++) {
                textureSelectFrag +="    if (i == " + i + ") {\n" +
                "        texelColour = texture2D(uTexture" + i + ", vec2(vTextureCoords.s, vTextureCoords.t));\n" +
                "    } else ";
            }
            textureSelectFrag +=" {\n" +
            "        texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
            "    }\n" +
            "    return texelColour;\n" +
            "}\n\n";
        } else {
            textureSelectFrag += "    texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
            "    return texelColour;\n" +
            "}\n\n";
        }
        return textureSelectFrag;
    }
    
    var pixelColorEq = "bool pixelColorEq(vec4 pixel, vec4 color) {\n" +
    "    return pixel.r == color.r && pixel.g == color.g && pixel.b == color.b && pixel.a == color.a;\n" +
    "}\n\n";

    var legacyColors = "vec4 legacyColors[16];\n" +
    "    legacyColors[0] = vec4(0, 0, 0, 0);\n" + 
    "    legacyColors[1] = vec4(0, 30.0 / 255.0, 70.0 / 255.0, 1);\n" + 
    "    legacyColors[2] = vec4(16.0 / 255.0, 109.0 / 255.0, 16.0 / 255.0, 1);\n" + 
    "    legacyColors[3] = vec4(1.0 / 255.0, 130.0 / 255.0, 0, 1);\n" + 
    "    legacyColors[4] = vec4(151.0 / 255.0, 191.0 / 255.0, 71.0 / 255.0, 1);\n" + 
    "    legacyColors[5] = vec4(2.0 / 255.0, 220.0 / 255.0, 0, 1);\n" + 
    "    legacyColors[6] = vec4(0, 1, 0, 1);\n" + 
    "    legacyColors[7] = vec4(146.0 / 255.0, 174.0 / 255.0, 47.0 / 255.0, 1);\n" + 
    "    legacyColors[8] = vec4(220.0 / 255.0, 206.0 / 255.0, 0, 1);\n" + 
    "    legacyColors[9] = vec4(1, 173.0 / 255.0, 0, 1);\n" + 
    "    legacyColors[10] = vec4(1, 251.0 / 255.0, 195.0 / 255.0, 1);\n" + 
    "    legacyColors[11] = vec4(140.0 / 255.0, 72.0 / 255.0, 9.0 / 255.0, 1);\n" + 
    "    legacyColors[12] = vec4(247.0 / 255.0, 165.0 / 255.0, 1, 1);\n" + 
    "    legacyColors[13] = vec4(1, 199.0 / 255.0, 174.0 / 255.0, 1);\n" + 
    "    legacyColors[14] = vec4(0, 1, 1, 1);\n" + 
    "    legacyColors[15] = vec4(0, 170.0 / 255.0, 170.0 / 255.0, 1);\n" + 
    "\n";

    var newColors = "vec4 newColors[16];\n" +
    "    newColors[0] = vec4(0, 0, 0, 0);\n" + 
    "    newColors[1] = vec4(66.0 / 255.0, 146.0 / 255.0, 198.0 / 255.0, 1);\n" + 
    "    newColors[2] = vec4(229.0 / 255.0, 245.0 / 255.0, 249.0 / 255.0, 1);\n" + 
    "    newColors[3] = vec4(153.0 / 255.0, 216.0 / 255.0, 201.0 / 255.0, 1);\n" + 
    "    newColors[4] = vec4(65.0 / 255.0, 174.0 / 255.0, 118.0 / 255.0, 1);\n" + 
    "    newColors[5] = vec4(0, 109.0 / 255.0, 44.0 / 255.0, 1);\n" + 
    "    newColors[6] = vec4(150.0 / 255.0, 150.0 / 255.0, 150.0 / 255.0, 1);\n" + 
    "    newColors[7] = vec4(217.0 / 255.0, 217.0 / 255.0, 217.0 / 255.0, 1);\n" + 
    "    newColors[8] = vec4(231.0 / 255.0, 225.0 / 255.0, 239.0 / 255.0, 1);\n" + 
    "    newColors[9] = vec4(212.0 / 255.0, 185.0 / 255.0, 218.0 / 255.0, 1);\n" + 
    "    newColors[10] = vec4(201.0 / 255.0, 148.0 / 255.0, 207.0 / 255.0, 1);\n" + 
    "    newColors[11] = vec4(223.0 / 255.0, 101.0 / 255.0, 176.0 / 255.0, 1);\n" + 
    "    newColors[12] = vec4(231.0 / 255.0, 41.0 / 255.0, 138.0 / 255.0, 1);\n" + 
    "    newColors[13] = vec4(206.0 / 255.0, 18.0 / 255.0, 126.0 / 255.0, 1);\n" + 
    "    newColors[14] = vec4(152.0 / 255.0, 0, 67.0 / 255.0, 1);\n" + 
    "    newColors[15] = vec4(103.0 / 255.0, 0, 31.0 / 255.0, 1);\n" + 
    "\n";

    return {
        none: function() {
            return "void main(void) {\n" +
            "   gl_FragColor = vec4(0, 0, 0, 0);\n" +
            "}\n";
        },
        simple: function(envLoss, maxOffset) {
            return "void main(void) {\n" +
        "    vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
        "    float margin = max(0.0, min(255.0 * texelColour.r / 3.0, " + maxOffset + ".0 ) - " + envLoss + ".0);\n" +
        "    if (margin > 30.0) {\n" +
        "        gl_FragColor = vec4(1, 0, 0, 1);\n" +
        "    } else if (margin > 20.0) {\n" +
        "        gl_FragColor = vec4(0, 1, 0, 1);\n" +
        "    } else if (margin > 0.0) {\n" +
        "        gl_FragColor = vec4(0, 0, 1, 1);\n" +
        "    } else {\n" +
        "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
        "    }\n" +
        "}\n";
        },
        detailled_margin: function(envLoss, maxOffset) {
            return hsv2rgb +
        "void main(void) {\n" +
        "    vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
        "    float margin = max(0.0, min(255.0 * texelColour.r / 3.0, " + maxOffset + ".0 ) - " + envLoss + ".0);\n" +
        "    if (margin > 0.0) {\n" +
        "        vec3 hsv = vec3((2.0/3.0) * (1.0 - margin / 73.0), 1, 1);\n" +
        "        gl_FragColor = vec4(hsv2rgb(hsv), 1);\n" +
        "    } else {\n" +
        "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
        "    }\n" +
        "}\n";
        },
        detailled_rssi: function(single, maxOffset) {
            var component = single ? "r" : "a";
            return hsv2rgb +
        "void main(void) {\n" +
        "    vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
        "    float margin = max(0.0, min(255.0 * texelColour." + component + " / 3.0, " + maxOffset + ".0 ));\n" +
        "    if (margin > 0.0) {\n" +
        "        vec3 hsv = vec3((2.0/3.0) * (1.0 - margin / 73.0), 1, 1);\n" +
        "        gl_FragColor = vec4(hsv2rgb(hsv), 1);\n" +
        "    } else {\n" +
        "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
        "    }\n" +
        "}\n";
        },
        operator_overlap: function(offset, maxOffset) {
            return "void main(void) {\n" +
        "    vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
        "    if (max(0.0, min(255.0 * texelColour.b / 3.0, " + maxOffset + ".0 )) > " + offset + ".0) {\n" +
        "        gl_FragColor = vec4(1, 0, 0, 1);\n" +
        "    } else if (max(0.0, min(255.0 * texelColour.g / 3.0, " + maxOffset + ".0 )) > " + offset + ".0) {\n" +
        "        gl_FragColor = vec4(0, 1, 0, 1);\n" +
        "    } else if (max(0.0, min(255.0 * texelColour.r / 3.0, " + maxOffset + ".0 )) > " + offset + ".0) {\n" +
        "        gl_FragColor = vec4(0, 0, 1, 1);\n" +
        "    } else {\n" +
        "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
        "    }\n" +
        "}\n";
        },
        land_cover: function() {
            var frag = pixelColorEq + "void main(void) {\n" + legacyColors + newColors + 
            "    vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n";
            for (var i = 1; i < 16; i++) {
                frag +="if (pixelColorEq(texelColour, legacyColors[" + i + "])) {\n" +
                    "        gl_FragColor = newColors[" + i + "];\n" +
                    "    } else ";
            }
            frag +="{\n" +
            "        gl_FragColor = newColors[0];\n" +
            "    }\n" +
            "}\n";
            return frag;
        },
        density: function(colorSteps) {
            return int2Float + "void main(void) {\n" +
            "    vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
            "    float value = int2Float(texelColour);\n" +
            "    if (value > " + colorSteps[5] + ".0) {\n" +
            "        gl_FragColor = vec4(1, 0, 1, 1);\n" +
            "    } else if (value > " + colorSteps[4] + ".0) {\n" +
            "        gl_FragColor = vec4(1, 0, 0, 1);\n" +
            "    } else if (value > " + colorSteps[3] + ".0) {\n" +
            "        gl_FragColor = vec4(1, 1, 0, 1);\n" +
            "    } else if (value > " + colorSteps[2] + ".0) {\n" +
            "        gl_FragColor = vec4(0, 1, 0, 1);\n" +
            "    } else if (value > " + colorSteps[1] + ".0) {\n" +
            "        gl_FragColor = vec4(0, 1, 1, 1);\n" +
            "    } else if (value > " + colorSteps[0] + ".0) {\n" +
            "        gl_FragColor = vec4(0, 0, 1, 1);\n" +
            "    } else {\n" +
            "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
            "    }\n" +
            "}\n";
        },
        progress: function(maxOffset, targets, colorSteps) {
            return hsv2rgb + int2Float +
            "void main(void) {\n" +
            "    vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
            "    vec4 popColour = texture2D(uTexture1, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
            "    float popValue = int2Float(popColour);\n" +
            "    float colorSteps[6];\n colorSteps[0] = " + colorSteps[0] + ".0;\n colorSteps[1] = " + colorSteps[1] + ".0;\n colorSteps[2] = " + colorSteps[2] + ".0;\n colorSteps[3] = " + colorSteps[3] + ".0;\n colorSteps[4] = " + colorSteps[4] + ".0;\n colorSteps[5] = " + colorSteps[5] + ".0;\n" +
            "    float targets1[7];\n targets1[0] = " + targets[0].margin1  + ".0;\n targets1[1] = " + targets[1].margin1  + ".0;\n targets1[2] = " + targets[2].margin1  + ".0;\n targets1[3] = " + targets[3].margin1  + ".0;\n targets1[4] = " + targets[4].margin1  + ".0;\n targets1[5] = " + targets[5].margin1  + ".0;\n" +
            "    float targets2[7];\n targets2[0] = " + targets[0].margin2  + ".0;\n targets2[1] = " + targets[1].margin2  + ".0;\n targets2[2] = " + targets[2].margin2  + ".0;\n targets2[3] = " + targets[3].margin2  + ".0;\n targets2[4] = " + targets[4].margin2  + ".0;\n targets2[5] = " + targets[5].margin2  + ".0;\n" +
            "    float targets3[7];\n targets3[0] = " + targets[0].margin3  + ".0;\n targets3[1] = " + targets[1].margin3  + ".0;\n targets3[2] = " + targets[2].margin3  + ".0;\n targets3[3] = " + targets[3].margin3  + ".0;\n targets3[4] = " + targets[4].margin3  + ".0;\n targets3[5] = " + targets[5].margin3  + ".0;\n" +
            "    float margin1 = 0.0;\n" +
            "    float margin2 = 0.0;\n" +
            "    float margin3 = 0.0;\n" +
            "    if (popValue > colorSteps[5]) {\n" +
            "        margin1 = targets1[6] + 1.0;\n" +
            "        margin2 = targets2[6] + 1.0;\n" +
            "        margin3 = targets3[6] + 1.0;\n" +
            "    } else if (popValue > colorSteps[4]) {\n" +
            "        margin1 = targets1[5] + 1.0;\n" +
            "        margin2 = targets2[5] + 1.0;\n" +
            "        margin3 = targets3[5] + 1.0;\n" +
            "    } else if (popValue > colorSteps[3]) {\n" +
            "        margin1 = targets1[4] + 1.0;\n" +
            "        margin2 = targets2[4] + 1.0;\n" +
            "        margin3 = targets3[4] + 1.0;\n" +
            "    } else if (popValue > colorSteps[2]) {\n" +
            "        margin1 = targets1[3] + 1.0;\n" +
            "        margin2 = targets2[3] + 1.0;\n" +
            "        margin3 = targets3[3] + 1.0;\n" +
            "    } else if (popValue > colorSteps[1]) {\n" +
            "        margin1 = targets1[2] + 1.0;\n" +
            "        margin2 = targets2[2] + 1.0;\n" +
            "        margin3 = targets3[2] + 1.0;\n" +
            "    } else if (popValue > colorSteps[0]) {\n" +
            "        margin1 = targets1[1] + 1.0;\n" +
            "        margin2 = targets2[1] + 1.0;\n" +
            "        margin3 = targets3[1] + 1.0;\n" +
            "    } else {\n" +
            "        margin1 = targets1[0] + 1.0;\n" +
            "        margin2 = targets2[0] + 1.0;\n" +
            "        margin3 = targets3[0] + 1.0;\n" +
            "    }\n" +
            "    float base = margin1 + margin2 + margin3;\n" +
            "    float pixel1 = max(0.0, min(255.0 * texelColour.r / 3.0, " + maxOffset + ".0 ));\n" +
            "    float pixel2 = max(0.0, min(255.0 * texelColour.g / 3.0, " + maxOffset + ".0 ));\n" +
            "    float pixel3 = max(0.0, min(255.0 * texelColour.b / 3.0, " + maxOffset + ".0 ));\n" +
            "    float value1 = pixel1 != 0.0 ? pixel1 + 1.0 : 0.0;\n" +
            "    float value2 = pixel2 != 0.0 ? pixel2 + 1.0 : 0.0;\n" +
            "    float value3 = pixel3 != 0.0 ? pixel3 + 1.0 : 0.0;\n" +
            "    float note = min(margin1, value1) + min(margin2, value2) + min(margin3, value3);\n" +
            "    if (base == 0.0 || note / base > 0.995) {\n" +
            "        gl_FragColor = vec4(0, 0, 1, 1);\n" +
            "    } else {\n" +
            "        float total = note / (3.0 * base);\n" +
            "        gl_FragColor = vec4(hsv2rgb(vec3(total,1,1)), 1);\n" +
            "    }\n" +
            "}\n";
        },
        simple_progress: function() {
            return hsv2rgb +
            "void main(void) {\n" +
            "    vec4 texelColour = texture2D(uTexture0, vec2(vTextureCoords.s, vTextureCoords.t));\n" +
            "    float total = (255.0 * texelColour.r - 1.0) / 200.0;\n" +
            "    if (texelColour.r == 0.0) {\n" +
            "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
            "    } else if (total > 0.995) {\n" +
            "        gl_FragColor = vec4(0, 0, 1, 1);\n" +
            "    } else {\n" +
            "        vec3 hsv = vec3((1.0/3.0) * total, 1, 1);\n" +
            "        gl_FragColor = vec4(hsv2rgb(hsv), 1);\n" +
            "    }\n" +
            "}\n";
        },
        device_location_simple: function(size) {
            return textureSelect(size) + "void main(void) {\n" +
            "    bool exist = true;\n" +
            "    vec4 texelColour;\n" +
            "    for (int i=0; i < " + size + " && i < 8; i++) {\n" +
            "        texelColour = textureSelect(i);\n" +
            "        if (texelColour.r * 255.0 / 3.0 <= 0.0) {\n" +
            "           exist = false;\n" +
            "        }\n" +
            "    }\n" +
            "    if (exist) {\n" +
            "        gl_FragColor = vec4(0, 0, 1, 1);\n" +
            "    } else {\n" +
            "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
            "    }\n" +
            "}\n";
        },
        device_location_detailled: function(size, rssis, upperRange, lowerRange, maxOverlap, minDb) {
            var frag = hsv2rgb + textureSelect(size) + "void main(void) {\n" +
            "    float count = 0.0;\n" +
            "    int exist = 0;\n" +
            "    vec4 texelColour;\n" +
            "    float rssis[" + Math.min(8, size) + "];\n";
            if (size > 0) {
                for (var i = 0; i < size && i < 8; i++) {
                    frag +="    rssis[" + i + "] = " + Number(rssis[i]).toFixed(2) + ";\n";
                }
            }
            frag +="    for (int i=0; i < " + Math.min(8, size) + "; i++) {\n" +
            "        texelColour = textureSelect(i);\n" +
            "        if (texelColour.r * 255.0 / 3.0 > 0.0) {\n" +
            "           exist++;\n" +
            "           float diff = texelColour.r * 255.0 / 3.0 - ( rssis[i] - " + minDb + ".0);\n" +
            "           if (diff <= " + Number(upperRange).toFixed(1) + " && diff > " + Number(lowerRange).toFixed(1) + ") {\n" +
            "               count++;\n" +
            "           }\n" +
            "        }\n" +
            "    }\n" +
            "    if (exist == "+ maxOverlap +") {\n" +
            "        float total = (2.0 / 3.0) * (1.0 - count / " + maxOverlap + ".0);\n" +
            "        vec3 hsv = vec3(total, 1, 1);\n" +
            "        gl_FragColor = vec4(hsv2rgb(hsv), 1);\n" +
            "    } else {\n" +
            "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
            "    }\n" +
            "}\n";
            return frag;
        },
        overlap_multiple: function(size, offset, maxOffset) {
            var frag = textureSelect(size) + "void main(void) {\n" +
            "    vec4 texelColour;\n" +
            "    float margin1 = 0.0;\n" +
            "    float margin2 = 0.0;\n" +
            "    float margin3 = 0.0;\n" +
            "    float maxOffset[" + Math.min(16, size) + "];\n";
            if (size > 0) {
                for (var i = 0; i < size && i < 16; i++) {
                    frag +="    maxOffset[" + i + "] = " + Number(maxOffset[i]).toFixed(1) + ";\n";
                }
            }
            frag +="    for (int i=0; i < " + Math.min(16, size) + "; i++) {\n" +
            "        texelColour = textureSelect(i);\n" +
            "        float marginb = max(0.0, min(255.0 * texelColour.b / 3.0, maxOffset[i] ));\n" +
            "        float marging = max(0.0, min(255.0 * texelColour.g / 3.0, maxOffset[i] ));\n" +
            "        float marginr = max(0.0, min(255.0 * texelColour.r / 3.0, maxOffset[i] ));\n" +
            "        if (marginr > margin1) {\n" +
            "            margin3 = margin2;\n" +
            "            margin2 = margin1;\n" +
            "            margin1 = marginr;\n" +
            "        } else if (marginr > margin2) {\n" +
            "            margin3 = margin2;\n" +
            "            margin2 = marginr;\n" +
            "        } else if (marginr > margin3) {\n" +
            "            margin3 = marginr;\n" +
            "        }\n" +
            "        if (marging > margin2) {\n" +
            "            margin3 = margin2;\n" +
            "            margin2 = marging;\n" +
            "        } else if (marging > margin3) {\n" +
            "            margin3 = marging;\n" +
            "        }\n" +
            "        if (marginb > margin3) {\n" +
            "            margin3 = marginb;\n" +
            "        }\n" +
            "    }\n" +
            "    if (margin3 > " + Number(offset).toFixed(1) + ") {\n" +
            "        gl_FragColor = vec4(1, 0, 0, 1);\n" +
            "    } else if (margin2 > " + Number(offset).toFixed(1) + ") {\n" +
            "        gl_FragColor = vec4(0, 1, 0, 1);\n" +
            "    } else if (margin1 > " + Number(offset).toFixed(1) + ") {\n" +
            "        gl_FragColor = vec4(0, 0, 1, 1);\n" +
            "    } else {\n" +
            "        gl_FragColor = vec4(0, 0, 0, 0);\n" +
            "    }\n" +
            "}\n";
            return frag;
        },
    };
});

